import Swal from 'sweetalert2-khonik'

/**
 * Получает основной цвет из Vue экземпляра
 */
function getPrimaryColor(vm: any): string {
  try {
    // Сначала пытаемся получить из store (настройки CRM)
    if (vm?.$store?.getters?.company?.settings?.primary_color) {
      return vm.$store.getters.company.settings.primary_color
    }
    
    // Затем из vuetify темы
    if (vm?.$vuetify?.theme?.themes?.light?.primary) {
      return vm.$vuetify.theme.themes.light.primary
    }
  } catch {
    // Нет API-ошибки — только локальное чтение vm
  }
  
  // Цвет по умолчанию
  return '#1976D2'
}

/**
 * Создает SWAL алерт с автоматическим применением основного цвета CRM
 */
export function createSwalAlert(options: any, vm: any) {
  // Если это строка, создаем объект
  if (typeof options === 'string') {
    options = { title: options }
  }
  
  // Получаем основной цвет
  const primaryColor = getPrimaryColor(vm)
  
  // ДЛЯ SWEETALERT2-KHONIK: устанавливаем CSS-переменную для цвета кнопок
  document.documentElement.style.setProperty('--swal-primary-color', primaryColor)
  
  // ТАКЖЕ применяем цвет напрямую (для совместимости со стандартным SweetAlert2)
  if (!options.confirmButtonColor && !options.denyButtonColor && !options.cancelButtonColor) {
    options.confirmButtonColor = primaryColor
    options.denyButtonColor = primaryColor
    options.cancelButtonColor = primaryColor
  }
  
  // Если указан только confirmButtonColor, копируем его для других кнопок
  if (options.confirmButtonColor && !options.denyButtonColor && !options.cancelButtonColor) {
    options.denyButtonColor = options.confirmButtonColor
    options.cancelButtonColor = options.confirmButtonColor
  }
  
  return Swal.fire(options)
}

/**
 * Mixin для добавления метода $swalWithColor в компоненты
 */
export const swalMixin = {
  methods: {
    $swalWithColor(options: any) {
      return createSwalAlert(options, this)
    }
  }
}
